"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "IERC1822Proxiable__factory", {
  enumerable: true,
  get: function get() {
    return _IERC1822Proxiable__factory.IERC1822Proxiable__factory;
  }
});
var _IERC1822Proxiable__factory = require("./IERC1822Proxiable__factory");